import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Typography, InputLabel, FormControl, FormHelperText } from '@material-ui/core'
import { userGroupBulkImportFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useStyles } from './Styles'
import Configuration from '../../../../../Services/Api/Configuration'
import { ExcelIcon } from '../../../../../utils/helpers'
import userGroupTemplate from '../../../../../assets/usersGroupsBulkTemplate.xlsx'

const UserGroupBulkImportForm = ({ onSubmit, cancelDialog, bulkImportHasError, clearBulkImportError, reloadPage }) => {
  const intl = useIntl()
  const classes = useStyles()
  const [filesName, setFilesName] = React.useState(intl.formatMessage({ id: 'UserGroupBulkImport.placeholder.file' }))

  const userGroupBulkImportFormActions = useFormik({
    initialValues: {
      userGroupsFile: null
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: userGroupBulkImportFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions, cancelDialog, reloadPage)
    })
  })

  const handleFileChange = (event, fieldName) => {
    event.preventDefault()
    clearBulkImportError()
    let files = event.currentTarget.files
    if (files && files.length > 0) {
      if (!!userGroupBulkImportFormActions.errors[fieldName]) {
        userGroupBulkImportFormActions.setFieldError(fieldName, null)
      }
      let file = files[0]
      const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
      if (types.includes(file.type)) {
        if (file.size <= Configuration.UPLOAD_FILE_SIZE) {
          userGroupBulkImportFormActions.setFieldValue(fieldName, file)
          setFilesName(event.target.value.replace(/.*(\/|\\)/, ''))
        } else {
          userGroupBulkImportFormActions.setFieldTouched(fieldName, true, true)
          setTimeout(() => userGroupBulkImportFormActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.largeFile' })), 50)
        }
      } else {
        userGroupBulkImportFormActions.setFieldTouched(fieldName, true, true)
        setTimeout(() => userGroupBulkImportFormActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.unSupported' })), 50)
      }
    }
  }

  // Reset file input when there's an error
  React.useEffect(() => {
    if (bulkImportHasError) {
      userGroupBulkImportFormActions.setFieldTouched('userGroupsFile', false)
      userGroupBulkImportFormActions.setFieldValue('userGroupsFile', null)
      setFilesName(intl.formatMessage({ id: 'UserGroupBulkImport.placeholder.file' }))
      const fileInput = document.getElementById('userGroupsFile')
      if (fileInput) {
        fileInput.value = ''
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkImportHasError])

  return (
    <form onSubmit={userGroupBulkImportFormActions.handleSubmit} noValidate autoComplete="off"
      className={classes.formWrapper}>
      <>
        <Typography className={classes.templateTitle} variant={'h6'}>
          <FormattedMessage id='UserGroupBulkImport.template.title' />
        </Typography>

        <div className={classes.templateDownloadWrapper}>
          <Button
            className={classes.templateDownload}
            color={'primary'}
            startIcon={<ExcelIcon htmlColor="#fff" />}
            href={userGroupTemplate}
            download='usersGroupsBulkTemplate.xlsx'
          >
            usersGroupsBulkTemplate.xlsx
          </Button>
        </div>

        <div className={classes.BasicInfoRow}>
          <InputLabel htmlFor="userGroupsFile">
            <FormattedMessage id='UserGroupBulkImport.label.file' />
            <span className={'required'}>*</span>:
          </InputLabel>
          <FormControl variant="outlined" margin="dense">
            <div className={classes.fileUploadWrapper} data-text={filesName}>
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                className={classes.fileUpload}
                name="userGroupsFile"
                id="userGroupsFile"
                type="file"
                onChange={(event) => handleFileChange(event, 'userGroupsFile')}
              />
            </div>
            {userGroupBulkImportFormActions.errors.userGroupsFile && userGroupBulkImportFormActions.touched.userGroupsFile && (
              <FormHelperText error={true}>{userGroupBulkImportFormActions.errors.userGroupsFile}</FormHelperText>
            )}
          </FormControl>
        </div>
      </>

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size='large' color='primary'
          onClick={userGroupBulkImportFormActions.handleSubmit}
          disabled={userGroupBulkImportFormActions.isSubmitting || !userGroupBulkImportFormActions.isValid}
        >
          <FormattedMessage id='UserGroupBulkImport.button.submit' />
        </Button>
      </div>
      {!!userGroupBulkImportFormActions.isSubmitting && <FormLoader loading={true} />}
    </form>
  )
}

export default UserGroupBulkImportForm

